var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"none font14 font_weight400 colo055"},[_vm._v(" 您搜索的“"),_c('span',{staticClass:"colo087"},[_vm._v(_vm._s(_vm.keyWords))]),_vm._v("”无结果，试试其他关键字 ")])}
var staticRenderFns = []

export { render, staticRenderFns }